type ArrowDownProps = {
  className?: string;
  fill?: string;
};

const ArrowDown = ({ className, fill = "#145758" }: ArrowDownProps) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      id="Vector"
      d="M11.4969 16.175V5C11.4969 4.71667 11.5927 4.47917 11.7844 4.2875C11.976 4.09583 12.2135 4 12.4969 4C12.7802 4 13.0177 4.09583 13.2094 4.2875C13.401 4.47917 13.4969 4.71667 13.4969 5V16.175L18.3969 11.275C18.5969 11.075 18.8302 10.9792 19.0969 10.9875C19.3635 10.9958 19.5969 11.1 19.7969 11.3C19.9802 11.5 20.076 11.7333 20.0844 12C20.0927 12.2667 19.9969 12.5 19.7969 12.7L13.1969 19.3C13.0969 19.4 12.9885 19.4708 12.8719 19.5125C12.7552 19.5542 12.6302 19.575 12.4969 19.575C12.3635 19.575 12.2385 19.5542 12.1219 19.5125C12.0052 19.4708 11.8969 19.4 11.7969 19.3L5.19688 12.7C5.01354 12.5167 4.92188 12.2875 4.92188 12.0125C4.92188 11.7375 5.01354 11.5 5.19688 11.3C5.39687 11.1 5.63438 11 5.90938 11C6.18438 11 6.42188 11.1 6.62188 11.3L11.4969 16.175Z"
      fill={fill}
    />
  </svg>
);

export default ArrowDown;
